import { FALLBACK_CONTACT } from "../constants";
import { buildSubject, generateEmailText } from "../summary";
import type { DepartmentConfig, FormState, Outcome } from "../types";
import { ResultError } from "./ResultError";
import { ResultSuccess } from "./ResultSuccess";

interface Props {
  form: FormState;
  config: DepartmentConfig;
  outcome: Outcome;
  submitting: boolean;
  onStartOver: () => void;
  onRetry: () => void;
  onBackToEdit: () => void;
}

export function ResultStep({
  form,
  config,
  outcome,
  submitting,
  onStartOver,
  onRetry,
  onBackToEdit,
}: Props) {
  const contactName = config.ui.contactName || FALLBACK_CONTACT.name;

  if (outcome.status === "error") {
    return (
      <ResultError
        errorKind={outcome.errorKind}
        submitting={submitting}
        onBackToEdit={onBackToEdit}
        onRetry={onRetry}
      />
    );
  }

  return (
    <ResultSuccess
      form={form}
      outcome={outcome}
      contactName={contactName}
      sentSubject={outcome.sentSubject ?? buildSubject(form)}
      sentBody={outcome.sentBody ?? generateEmailText(form)}
      onStartOver={onStartOver}
    />
  );
}
